import { createSlice } from '@reduxjs/toolkit'

export const headerSlice = createSlice({
    name: 'header',
    initialState: {
        pageTitle: "Home",  // current page title state management
        breadcrumbs: [],  // breadcrumb trail for navigation
        noOfNotifications : 15,  // no of unread notifications
        newNotificationMessage : "",  // message of notification to be shown
        newNotificationStatus : 1,
        isSidebarCollapsed: false  // sidebar collapse state
    },
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload.title
        },

        setBreadcrumbs: (state, action) => {
            state.breadcrumbs = action.payload
        },


        removeNotificationMessage: (state, action) => {
            state.newNotificationMessage = ""
        },

        showNotification: (state, action) => {
            state.newNotificationMessage = action.payload.message
            state.newNotificationStatus = action.payload.status
        },

        toggleSidebar: (state) => {
            state.isSidebarCollapsed = !state.isSidebarCollapsed
        },

        setSidebarCollapsed: (state, action) => {
            state.isSidebarCollapsed = action.payload
        }
    }
})

export const { setPageTitle, setBreadcrumbs, removeNotificationMessage, showNotification, toggleSidebar, setSidebarCollapsed } = headerSlice.actions

export default headerSlice.reducer
